<template>
  <el-dialog
    :title="$t(`channel.titles.${isAdd ? 'add' : 'editor'}`)"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <el-row>
      <el-form :model="form" v-bind="formRules">
        <el-form-item :label="$t('device.serialNumber')" prop="serialNumber">
          <el-input v-model="form.serialNumber" />
        </el-form-item>

        <el-form-item :label="$t('device.phone')" prop="phone">
          <el-input v-model.trim="form.phone" />
        </el-form-item>
        <el-form-item :label="$t('device.zalopayId')" prop="zalopayId" v-if="isZalo">
          <el-input v-model.trim="form.zalopayId" />
        </el-form-item>
        <!-- <el-form-item :label="$t('device.supplier')" prop="supplier" v-if="isZalo||isViettel">
          <el-input v-model.trim="form.supplier" />
        </el-form-item>
        <el-form-item :label="$t('momoLogs.comment')" prop="remark" v-if="isZalo||isViettel">
          <el-input v-model.trim="form.remark" />
        </el-form-item> -->
        <el-form-item :label="$t('device.userName')" prop="userName" v-if="isZalo||isName">
          <el-input v-model="form.userName" />
        </el-form-item>
        <el-form-item :label="$t('device.password')" prop="password" v-if="isZalo||isName">
          <el-input v-model.trim="form.password" oninput="value=value.replace(/[^\d]/g, '')" />
        </el-form-item>
        
        <el-form-item :label="$t('device.connectionStatus')" prop="connectionStatus">
          <el-select v-model="form.connectionStatus">
            <el-option
              v-for="item in connectionStatusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('device.limits')" prop="limits">
          <el-input v-model="form.limits" />
        </el-form-item>

        <el-form-item :label="$t('device.monthLimits')" prop="monthLimits">
          <el-input v-model="form.monthLimits" />
        </el-form-item>
        <el-form-item :label="$t('device.company')" prop="company">
          <el-input v-model="form.company" />
        </el-form-item>
      </el-form>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="warning" @click="handleEmpty()">{{
        $t('btns.empty')
      }}</el-button>
      <el-button size="mini" @click="closeDialog()">{{ $t('btns.cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="handleEditor()">{{
        $t('btns.confirm')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { debounce } from 'lodash';
import { isNumber } from '@/utils/validate';
export default {
  props: [
    'statusData',
    'serviceTypes',
    'channelTypeList',
    'channelTypeData',
    'isZalo',
    'isName',
    'isViettel'
  ],
  data() {
    return {
      dialogVisible: false,
      isAdd: true,
      form: {
        //设备号
        serialNumber: '',
        //手机号
        phone: '',
        // 用户名
        userName: '',
        //连接状态
        connectionStatus: 0,
        //当天收款限额
        limits: '',
        //当月收款限额
        monthLimits: '',
        zalopayId: '',
        company:'',
      },
      connectionStatusOption: this.$t('device.add_connectionStatusOption')
    };
  },
  computed: {},
  created() {
    this.formRules = {
      ref: 'form',
      'label-width': 'auto',
      inline: false,
      size: 'small',
      rules: {
        serialNumber: [
          {
            required: true,
            message: this.$t('device.rules.serialNumber'),
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: this.$t('device.rules.phone'),
            trigger: 'change'
          }
        ],
        connectionStatus: [
          {
            required: true,
            message: this.$t('device.rules.connectionStatus'),
            trigger: 'change'
          }
        ],
        limits: [
          {
            required: true,
            message: this.$t('device.rules.limits'),
            trigger: 'blur'
          }
        ],
        monthLimits: [
          {
            required: true,
            message: this.$t('device.rules.monthLimits'),
            trigger: 'change'
          }
        ],
        company: [
          {
            required: true,
            message: this.$t('device.rules.company'),
            trigger: 'blur'
          }
        ],
      }
    };
    this.handleEditor = debounce(this._handleEditor, 300);
  },
  methods: {
    init(row) {
      this.dialogVisible = true;
      if (row) {
        this.isAdd = false;
        // 初始化表单数据

        Object.keys(this.form).forEach((key) => {
          if (row[key] === 0 || row[key]) {
            this.form[key] = row[key];
          }
        });
        this.form.id = row.id;
      }else {
        this.isAdd = true;
      }
    },

    /* --------------------------------- 事件驱动函数 --------------------------------- */
    handleEmpty() {
      this.form = {
        //设备号
        serialNumber: '',
        //手机号
        phone: '',
        //连接状态
        connectionStatus: 0,
        //当天收款限额
        limits: '',
        //当月收款限额
        monthLimits: '',
        company:'',
      };
    },
    _handleEditor() {
      this.$refs.form.validate(
        (valid) =>
          valid &&
          this.$emit(this.isAdd ? 'doConfAdd' : 'doConfUpdate', this.form, () => {
            this.dialogVisible = false;
          })
      );
    },
    closeDialog () {
      this.dialogVisible = false;
      this.handleEmpty()
    },
  }
};
</script>

<style scoped>
 .dialog-footer {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/device/editor.vue